var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 10.0003L17.9845 8.32841C18.0793 8.23362 18.0793 8.07958 17.9845 7.98479L17.6408 7.64117C17.546 7.54638 17.392 7.54638 17.2972 7.64117L15.625 9.31278L13.9531 7.64086C13.8583 7.54607 13.7043 7.54607 13.6095 7.64086L13.2658 7.98448C13.171 8.07928 13.171 8.23331 13.2658 8.3281L14.9375 10.0003L13.2655 11.6722C13.1707 11.767 13.1707 11.9211 13.2655 12.0159L13.6092 12.3595C13.7039 12.4543 13.858 12.4543 13.9528 12.3595L15.625 10.6879L17.2969 12.3598C17.3917 12.4546 17.5457 12.4546 17.6405 12.3598L17.9842 12.0162C18.0789 11.9214 18.0789 11.7673 17.9842 11.6725L16.3125 10.0003ZM9.54284 4.16699C9.36328 4.16699 9.18068 4.23322 9.03303 4.38119L6.32995 7.08366H3.22917C2.8263 7.08366 2.5 7.40996 2.5 7.81283V12.1878C2.5 12.5904 2.8263 12.917 3.22917 12.917H6.32995L9.03303 15.6195C9.18099 15.7674 9.36358 15.8337 9.54284 15.8337C9.91745 15.8337 10.2778 15.5444 10.2778 15.1039V4.89677C10.2778 4.45592 9.91714 4.16699 9.54284 4.16699ZM9.30555 14.5172L7.01719 12.2294L6.73251 11.9448H3.47222V8.05588H6.73251L7.01719 7.7712L9.30555 5.48344V14.5172Z",
    fill: "#0e0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.a7f76b316c5aed8a90fc40a6b18616c6.svg";
export { ForwardRef as ReactComponent };